export const OPTIONS = {
    componentRestrictions: { country: ['us', 'ca'] },
    fields: ['place_id', 'name', 'address_components', 'formatted_address'],
    types: ['address'],
};

export interface AddressType {
    street: string;
    country: string;
    zipCode: string;
    state: string;
    city: string;
}
